import { ACTIONS_CONFIG } from '@config/actions.config';
import { LANGUAGE_CONFIG } from '@config/language.config';
import { SERVICES_CONFIG } from '@config/services.config';
import { Menu } from '@shared/interfaces/menu';

export const TYPE_SINGLE_CONFIG = 'single';
export const TYPE_ACCORDION_CONFIG = 'accordion';
export const TYPE_PRIMARY_CONFIG = 'primary';
export const TYPE_SECOND_CONFIG = 'second';

export class SetMenu {
  menu: Array<Menu> = [
    // Antilavado
    {
      type: TYPE_ACCORDION_CONFIG,
      id: 'amlLimits',
      name: LANGUAGE_CONFIG.menu.amlLimits,
      link: '',
      icon: 'eye',
      show: true,
      home: true,
      access: {
        primary: {
          type: '',
          service: []
        },
        second: []
      },
      child: [
        {
          id: 'customers',
          name: LANGUAGE_CONFIG.menu.customersFilter,
          link: 'clientes',
          icon: 'user-tie',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.search.id,
              service: [SERVICES_CONFIG.customers.findbydocument.context]
            },
            second: []
          }
        },
        {
          id: 'limits',
          name: LANGUAGE_CONFIG.menu.limits,
          link: 'topes',
          icon: 'hand-paper',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.list.id,
              service: [SERVICES_CONFIG.limits.findall.context]
            },
            second: [
              {
                type: ACTIONS_CONFIG.edit.id,
                service: [
                  SERVICES_CONFIG.limits.findall.context,
                  SERVICES_CONFIG.limits.update.context,
                  SERVICES_CONFIG.segments.findwithoutamllimit.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.add.id,
                service: [
                  SERVICES_CONFIG.limits.findall.context,
                  SERVICES_CONFIG.limits.add.context,
                  SERVICES_CONFIG.segments.findwithoutamllimit.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.delete.id,
                service: [
                  SERVICES_CONFIG.limits.findall.context,
                  SERVICES_CONFIG.limits.delete.context
                ],
                show: true
              }
            ]
          }
        }
      ]
    },
    // Comisiones
    {
      type: TYPE_SINGLE_CONFIG,
      id: 'commissions',
      name: LANGUAGE_CONFIG.menu.commissions,
      link: 'comisiones',
      icon: 'dollar-sign',
      show: true,
      home: true,
      access: {
        primary: {
          type: ACTIONS_CONFIG.list.id,
          service: [SERVICES_CONFIG.commissions.findall.context]
        },
        second: [
          {
            type: ACTIONS_CONFIG.edit.id,
            service: [
              SERVICES_CONFIG.commissions.findall.context,
              SERVICES_CONFIG.commissions.update.context,
              SERVICES_CONFIG.channels.findall.context
            ],
            show: true
          },
          {
            type: ACTIONS_CONFIG.add.id,
            service: [
              SERVICES_CONFIG.commissions.findall.context,
              SERVICES_CONFIG.commissions.add.context,
              SERVICES_CONFIG.channels.findall.context
            ],
            show: true
          },
          {
            type: ACTIONS_CONFIG.delete.id,
            service: [
              SERVICES_CONFIG.commissions.findall.context,
              SERVICES_CONFIG.commissions.delete.context
            ],
            show: true
          }
        ]
      },
      child: []
    },
    // eportes
    {
      type: TYPE_ACCORDION_CONFIG,
      id: 'reports',
      name: LANGUAGE_CONFIG.menu.reports,
      link: 'Reportes',
      icon: 'file-export',
      show: true,
      home: true,
      access: {
        primary: {
          type: '',
          service: []
        },
        second: []
      },
      child: [
        {
          id: 'totalCosts',
          name: LANGUAGE_CONFIG.menu.totalCosts,
          link: 'totals-costs',
          icon: 'money-check-alt',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.download.id,
              service: [
                SERVICES_CONFIG.totalsCost.attachmenttotalcostsreport.context,
                SERVICES_CONFIG.totalsCost.attachmensentinelreport.context
              ]
            },
            second: []
          }
        }
      ]
    },
    // Contabilidad
    {
      type: TYPE_ACCORDION_CONFIG,
      id: 'accounting',
      name: LANGUAGE_CONFIG.menu.accounting,
      link: '',
      icon: 'calculator',
      show: true,
      home: true,
      access: {
        primary: {
          type: '',
          service: []
        },
        second: []
      },
      child: [
        {
          id: 'eventCodes',
          name: LANGUAGE_CONFIG.menu.eventCodes,
          link: 'codigos-eventos',
          icon: 'code',
          show: false,
          home: false,
          access: {
            primary: {
              type: '',
              service: []
            },
            second: []
          }
        },
        {
          id: 'movementInterface',
          name: LANGUAGE_CONFIG.menu.movementInterface,
          link: 'interfaz-movimientos',
          icon: 'exchange-alt',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.download.id,
              service: [
                SERVICES_CONFIG.movementInterface.attachmentmovementreport
                  .context
              ]
            },
            second: []
          }
        },
        {
          id: 'balanceInterface',
          name: LANGUAGE_CONFIG.menu.balanceInterface,
          link: 'interfaz-saldos',
          icon: 'boxes',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.download.id,
              service: [
                SERVICES_CONFIG.balanceInterface.attachmentbalanceinterface
                  .context
              ]
            },
            second: []
          }
        },
        {
          id: 'masterTransfers',
          name: LANGUAGE_CONFIG.menu.masterTransfers,
          link: 'maestro-giros',
          icon: 'cubes',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.download.id,
              service: [
                SERVICES_CONFIG.masterTransfers.attachmentmastergiros.context
              ]
            },
            second: []
          }
        },
        {
          id: 'transactionsEvents',
          name: LANGUAGE_CONFIG.menu.transactionsEvents,
          link: 'transacciones-eventos',
          icon: 'clone',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.download.id,
              service: [
                SERVICES_CONFIG.transactionsEvents.attachmenttransactionsevents
                  .context
              ]
            },
            second: []
          }
        },
        {
          id: 'logReport',
          name: LANGUAGE_CONFIG.menu.logReport,
          link: 'transacciones-log-eventos',
          icon: 'archive',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.download.id,
              service: [
                SERVICES_CONFIG.logReport.attachmenttransactionslogevents
                  .context
              ]
            },
            second: []
          }
        }
      ]
    },
    // Control de acceso
    {
      type: TYPE_ACCORDION_CONFIG,
      id: 'accessControl',
      name: LANGUAGE_CONFIG.menu.accessControl,
      link: '',
      icon: 'id-card',
      show: true,
      home: true,
      access: {
        primary: {
          type: '',
          service: []
        },
        second: []
      },
      child: [
        {
          id: 'roles',
          name: LANGUAGE_CONFIG.menu.roles,
          link: 'roles',
          icon: 'users',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.list.id,
              service: [SERVICES_CONFIG.roles.findall.context]
            },
            second: [
              {
                type: ACTIONS_CONFIG.edit.id,
                service: [
                  SERVICES_CONFIG.roles.findall.context,
                  SERVICES_CONFIG.roles.findbyid.context,
                  SERVICES_CONFIG.roles.update.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.add.id,
                service: [
                  SERVICES_CONFIG.roles.findall.context,
                  SERVICES_CONFIG.roles.findbyid.context,
                  SERVICES_CONFIG.roles.add.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.detail.id,
                service: [
                  SERVICES_CONFIG.roles.findall.context,
                  SERVICES_CONFIG.roles.findbyid.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.delete.id,
                service: [
                  SERVICES_CONFIG.roles.findall.context,
                  SERVICES_CONFIG.roles.delete.context
                ],
                show: true
              }
            ]
          }
        },
        {
          id: 'users',
          name: LANGUAGE_CONFIG.menu.users,
          link: 'usuarios',
          icon: 'user-circle',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.list.id,
              service: [SERVICES_CONFIG.users.findall.context]
            },
            second: [
              {
                type: ACTIONS_CONFIG.edit.id,
                service: [
                  SERVICES_CONFIG.users.findall.context,
                  SERVICES_CONFIG.users.update.context,
                  SERVICES_CONFIG.roles.findall.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.add.id,
                service: [
                  SERVICES_CONFIG.users.findall.context,
                  SERVICES_CONFIG.users.add.context,
                  SERVICES_CONFIG.roles.findall.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.delete.id,
                service: [
                  SERVICES_CONFIG.users.findall.context,
                  SERVICES_CONFIG.users.delete.context
                ],
                show: true
              }
            ]
          }
        }
      ]
    },
    // Giros
    {
      type: TYPE_ACCORDION_CONFIG,
      id: 'transfers',
      name: LANGUAGE_CONFIG.menu.transfers,
      link: '',
      icon: 'sync-alt',
      show: true,
      home: true,
      access: {
        primary: {
          type: '',
          service: []
        },
        second: []
      },
      child: [
        {
          id: 'transfersReference',
          name: LANGUAGE_CONFIG.menu.transfersReference,
          link: 'giros-referencia',
          icon: 'barcode',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.search.id,
              service: [
                SERVICES_CONFIG.transfersReference.findbyreference.context
              ]
            },
            second: [
              {
                type: ACTIONS_CONFIG.edit.id,
                service: [
                  SERVICES_CONFIG.transfersReference.findbyreference.context,
                  SERVICES_CONFIG.transfersReference.updatecellphone.context,
                  SERVICES_CONFIG.transfersReference.canupdatecellphone.context,
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.editId.id,
                service: [
                  SERVICES_CONFIG.transfersReference.findbyreference.context,
                  SERVICES_CONFIG.transfersReference.updatedocument.context,
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.cancel.id,
                service: [
                  SERVICES_CONFIG.transfersReference.findbyreference.context,
                  SERVICES_CONFIG.transfersReference.avoid.context,
                  SERVICES_CONFIG.transfersReference.canavoid.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.reverseadm.id,
                service: [
                  SERVICES_CONFIG.transfersReference.findbyreference.context,
                  SERVICES_CONFIG.transfersReference.reverseadm.context,
                  SERVICES_CONFIG.transfersReference.canreverseadm.context
                ],
                show: true
              }
            ]
          }
        },
        {
          id: 'transfersCustomer',
          name: LANGUAGE_CONFIG.menu.transfersCustomer,
          link: 'giros-cliente',
          icon: 'user-tag',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.search.id,
              service: [
                SERVICES_CONFIG.transfersCustomer.findbycustomerdate.context
              ]
            },
            second: [
              {
                type: ACTIONS_CONFIG.detail.id,
                service: [
                  SERVICES_CONFIG.transfersReference.findbyreference.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.edit.id,
                service: [
                  SERVICES_CONFIG.transfersReference.findbyreference.context,
                  SERVICES_CONFIG.transfersReference.updatecellphone.context,
                  SERVICES_CONFIG.transfersReference.canupdatecellphone.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.editId.id,
                service: [
                  SERVICES_CONFIG.transfersReference.findbyreference.context,
                  SERVICES_CONFIG.transfersReference.updatedocument.context,
                  SERVICES_CONFIG.transfersReference.canupdatecellphone.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.cancel.id,
                service: [
                  SERVICES_CONFIG.transfersReference.findbyreference.context,
                  SERVICES_CONFIG.transfersReference.avoid.context,
                  SERVICES_CONFIG.transfersReference.canavoid.context
                ],
                show: true
              },
              {
                type: ACTIONS_CONFIG.reverseadm.id,
                service: [
                  SERVICES_CONFIG.transfersReference.findbyreference.context,
                  SERVICES_CONFIG.transfersReference.reverseadm.context,
                  SERVICES_CONFIG.transfersReference.canreverseadm.context
                ],
                show: true
              }
            ]
          }
        },
        {
          id: 'templates',
          name: LANGUAGE_CONFIG.menu.templates,
          link: 'plantillas',
          icon: 'comment-alt',
          show: false,
          home: false,
          access: {
            primary: {
              type: '',
              service: []
            },
            second: []
          }
        }
      ]
    },
    // Parametros Generales
    {
      type: TYPE_ACCORDION_CONFIG,
      id: 'parameters',
      name: LANGUAGE_CONFIG.menu.generalParameters,
      link: '',
      icon: 'cogs',
      show: true,
      home: true,
      access: {
        primary: {
          type: '',
          service: []
        },
        second: []
      },
      child: [
        {
          id: 'channels',
          name: LANGUAGE_CONFIG.menu.channels,
          link: 'canales',
          icon: 'link',
          show: false,
          home: false,
          access: {
            primary: {
              type: '',
              service: []
            },
            second: []
          }
        },
        {
          id: 'constants',
          name: LANGUAGE_CONFIG.menu.constants,
          link: 'constantes',
          icon: 'toolbox',
          show: false,
          home: false,
          access: {
            primary: {
              type: '',
              service: []
            },
            second: []
          }
        },
        {
          id: 'accountingEvents',
          name: LANGUAGE_CONFIG.menu.accountingEvents,
          link: 'eventos-contables',
          icon: 'cash-register',
          show: false,
          home: false,
          access: {
            primary: {
              type: '',
              service: []
            },
            second: []
          }
        },
        {
          id: 'transactionalEvents',
          name: LANGUAGE_CONFIG.menu.transactionalEvents,
          link: 'eventos-transaccionales',
          icon: 'receipt',
          show: false,
          home: false,
          access: {
            primary: {
              type: '',
              service: []
            },
            second: []
          }
        },
        {
          id: 'accountingGroups',
          name: LANGUAGE_CONFIG.menu.accountingGroups,
          link: 'grupos-contables',
          icon: 'th-large',
          show: false,
          home: false,
          access: {
            primary: {
              type: '',
              service: []
            },
            second: []
          }
        },
        {
          id: 'paymentMethods',
          name: LANGUAGE_CONFIG.menu.paymentMethods,
          link: 'medios-pago',
          icon: 'hand-holding-usd',
          show: false,
          home: false,
          access: {
            primary: {
              type: '',
              service: []
            },
            second: []
          }
        },
        {
          id: 'rules',
          name: LANGUAGE_CONFIG.menu.rules,
          link: 'reglas',
          icon: 'ruler',
          show: false,
          home: false,
          access: {
            primary: {
              type: '',
              service: []
            },
            second: []
          }
        },
        {
          id: 'segments',
          name: LANGUAGE_CONFIG.menu.segments,
          link: 'segmentos',
          icon: 'flag',
          show: true,
          home: true,
          access: {
            primary: {
              type: ACTIONS_CONFIG.list.id,
              service: [SERVICES_CONFIG.segments.findall.context]
            },
            second: [
              {
                type: ACTIONS_CONFIG.edit.id,
                service: [SERVICES_CONFIG.segments.update.context],
                show: true
              },
              {
                type: ACTIONS_CONFIG.add.id,
                service: [SERVICES_CONFIG.segments.add.context],
                show: true
              },
              {
                type: ACTIONS_CONFIG.delete.id,
                service: [SERVICES_CONFIG.segments.delete.context],
                show: true
              }
            ]
          }
        },
        {
          id: 'status',
          name: LANGUAGE_CONFIG.menu.status,
          link: 'estados',
          icon: 'bookmark',
          show: false,
          home: false,
          access: {
            primary: {
              type: '',
              service: []
            },
            second: []
          }
        }
      ]
    },
    // Logs
    {
      type: TYPE_SINGLE_CONFIG,
      id: 'logs',
      name: LANGUAGE_CONFIG.menu.logs,
      link: 'logs',
      icon: 'database',
      show: true,
      home: false,
      access: {
        primary: {
          type: '',
          service: []
        },
        second: []
      },
      child: []
    }
  ];
}
